import { createType } from 'reducers/utils/helpers';
import { generateTypes } from '../../utils/HttpReducerHelper';

export const OPEN_UPDATE_MATCH_STATUS_MODAL = createType(
  'FUNDING_MATCH',
  'OPEN_UPDATE_MATCH_STATUS_MODAL',
);
export const CLOSE_UPDATE_MATCH_STATUS_MODAL = createType(
  'FUNDING_MATCH',
  'CLOSE_UPDATE_MATCH_STATUS_MODAL',
);

export const updateMatchStatus = generateTypes('FUNDING_MATCH', 'UPDATE_FUNDING_MATCH_STATUS');

export const REQUEST_OFFER_UPLOAD = createType('FUNDING_MATCH', 'REQUEST_OFFER_UPLOAD');
export const REQUEST_OFFER_UPLOAD_SUCCESS = createType(
  'FUNDING_MATCH',
  'REQUEST_OFFER_UPLOAD_SUCCESS',
);
export const REQUEST_OFFER_UPLOAD_FAILURE = createType(
  'FUNDING_MATCH',
  'REQUEST_OFFER_UPLOAD_FAILURE',
);
export const REQUEST_OFFER_UPLOAD_PROGRESS = createType(
  'FUNDING_MATCH',
  'REQUEST_OFFER_UPLOAD_PROGRESS',
);

export const REQUEST_REMOVE_OFFER_DOCUMENT = createType(
  'FUNDING_MATCH',
  'REQUEST_REMOVE_OFFER_DOCUMENT',
);
export const REQUEST_REMOVE_OFFER_DOCUMENT_SUCCESS = createType(
  'FUNDING_MATCH',
  'REQUEST_REMOVE_OFFER_DOCUMENT_SUCCESS',
);
